import IconButtonComponent from '../../Basic/IconButton/IconButton.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import TextComponent from '../../Typography/Text/Text.mjs';
import Duration from '../Duration/Duration.mjs';
import styled from 'styled-components';

const StyledTextContainer = styled.div `
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const StyledDate = styled(TextComponent) `
  display: none;
  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    display: block;
  }
`;
const StyledMediaCardHeading = styled(Heading) `
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  transition-property: opacity;
  transition-duration: ${props => props.theme.animation.duration.quick1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    -webkit-line-clamp: 2;
  }
`;
const StyledMediaCardImageContainer = styled.div `
  position: relative;
  width: 120px;
  height: 68px;
  flex-shrink: 0;
`;
const StyledIconButton = styled(IconButtonComponent) `
  opacity: 0;
  background-color: transparent;
  position: absolute;
  z-index: ${props => props.theme.zIndex.minor};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  transition-property: opacity, background-color;
  transition-duration: ${props => props.theme.animation.duration.quick1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};

  svg {
    width: 24px;
    height: 24px;
  }
`;
const StyledMediaCardDuration = styled(Duration) `
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${props => props.theme.zIndex.minor};
  transition-property: opacity;
  transition-duration: ${props => props.theme.animation.duration.quick1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};
`;
const StyledMediaCardContainer = styled.a `
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 120px;
  text-decoration: none;

  @media (pointer: fine) {
    &:hover {
      ${StyledMediaCardHeading} {
        opacity: 0.7;
      }

      ${StyledIconButton} {
        opacity: 1;
        background-color: ${props => props.theme.colors.midnightBlue}80;
      }

      ${StyledMediaCardDuration} {
        opacity: 0;
      }
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: row;
    width: 100%;
  }
`;
const StyledMediaCardImage = styled.img `
  width: 100%;
  height: 100%;
`;

export { StyledDate, StyledIconButton, StyledMediaCardContainer, StyledMediaCardDuration, StyledMediaCardHeading, StyledMediaCardImage, StyledMediaCardImageContainer, StyledTextContainer };
//# sourceMappingURL=SmallMediaCard.styles.mjs.map
